<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark color="primary">
      <v-toolbar-title>Claim Codes - {{ this.claimID }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card tile>
      <v-card-text class="py-3">
        <v-row v-if="this.requestError == true && this.loading != true">
          <v-col>
            <v-alert type="error">Error getting claim data.</v-alert>
          </v-col>
        </v-row>
        <v-row v-else-if="this.requestError == false && this.loading != true">
          <v-col cols="12" lg="6" v-if="claim_data.PROCEDURE_CODES.length > 0">
            <v-card outlined height="100%">
              <v-card-title>Procedure/Special Codes</v-card-title>
              <v-card-text>
                <ul class="code-list">
                  <li v-for="code in claim_data.PROC">
                    <v-chip small class="mb-1" color="error">{{ code.code }}</v-chip>
                    {{ code.desc }}
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" v-if="claim_data.DIAG.length > 0">
            <v-card outlined height="100%">
              <v-card-title>Diagnostic Codes</v-card-title>
              <v-card-text>
                <ul class="code-list">
                  <li v-for="code in claim_data.DIAG">
                    <v-chip small class="mb-1" color="error">{{ code.code }}</v-chip>
                    {{ code.desc }}
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" v-if="claim_data.REV.length > 0">
            <v-card outlined height="100%">
              <v-card-title>Revenue Codes</v-card-title>
              <v-card-text>
                <ul class="code-list">
                  <li v-for="code in claim_data.REV">
                    <v-chip small class="mb-1" color="secondary">{{ code.code }}</v-chip>
                    {{ code.desc }}
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" v-if="claim_data.DRG.length > 0">
            <v-card outlined height="100%">
              <v-card-title>DRG Codes</v-card-title>
              <v-card-text>
                <ul class="code-list">
                  <li v-for="code in claim_data.DRG">
                    <v-chip small class="mb-1" color="secondary darken-2">{{ code.code }}</v-chip>
                    {{ code.desc }}
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="text-center">
            <v-progress-circular
              indeterminate
              color="secondary"
              :size="50"
              :width="3"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ClaimDetails',
  props: ['value', 'insurance', 'claimID'],
  data() {
    return {
      dialog: false,
      loading: true,
      requestError: false,
      claim_data: [],
    };
  },
  methods: {
    async getClaim() {
      this.loading = true;
      this.requestError = false;
      this.claim_data = [];

      const url = `/api/claims/codes/${this.insurance}/${this.claimID}`;
      axios
        .get(url)
        .then((res) => {
          this.claim_data = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.requestError = true;
          this.loading = false;
        });
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async claimID() {
      if (this.value == true && this.claimID != null && this.claimID != 0 && this.claimID != '') {
        this.getClaim();
      }
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
